import {
  AGREGAR_GASTO,
  OBTENER_GASTOS,
  ELIMINAR_GASTO,
  GASTO_ACTUAL,
  ACTUALIZAR_GASTO,
} from "../../types";
export default (state, action) => {
  switch (action.type) {
    case AGREGAR_GASTO:
      console.log(action.payload);
      return {
        ...state,
        gastos: [...state.gastos, action.payload],
      };
    case OBTENER_GASTOS:
      return {
        ...state,
        gastos: action.payload,
      };
    case GASTO_ACTUAL:
      return {
        ...state,
        gastoSeleccionado: action.payload,
      };
    case ELIMINAR_GASTO:
      return {
        ...state,
        gastos: state.gastos.filter((gasto) => gasto._id !== action.payload),
      };
    case ACTUALIZAR_GASTO:
      return {
        ...state,
        gastos: state.gastos.map((gasto) =>
          gasto._id === action.payload._id ? action.payload : gasto
        ),
        gastoSeleccionado: null,
      };

    default:
      return state;
  }
};
